import React from "react";
import { Button, Flex, Image } from "antd"; // Replace 'your-ui-library' with your actual library
import plusIcon from "../../assets/img/add-button.svg";
import { Link } from "react-router-dom";

const PageTitle = ({
  title,
  buttonText,
  buttonLink,
  rightIcon = true,
  handleClick,
  isShowButton = true,
  type = "link",
}) => {
  return (
    <Flex gap="middle" justify="space-between" className="mb-4">
      <div className="text-brand flex items-center gap-x-3">
        <h1 className="lg:text-lg text-base  font-monaSansMedium">{title}</h1>
      </div>

      {rightIcon &&
        isShowButton &&
        (type === "btn" ? (
          <Button
            onClick={handleClick}
            className="root-btn text-white hover:text-white py-5 flex-center radius"
            icon={<Image src={plusIcon} alt="Plus Icon" preview={false} />}
          >
            {buttonText}
          </Button>
        ) : (
          <Link to={buttonLink}>
            <Button
              className="root-btn text-white hover:text-white py-5 flex-center radius"
              icon={<Image src={plusIcon} alt="Plus Icon" preview={false} />}
            >
              {buttonText}
            </Button>
          </Link>
        ))}
    </Flex>
  );
};

export default PageTitle;
